export default "__VITE_ASSET__DcWY28UG__"